<template>
  <div id="weather-launcher-module">
    <template v-if="weatherData.message">
      <div id="alt-weather">
        <span id="msg">{{ weatherData.message }}</span>
        <span id="today-s-date">{{ clock | longDate }}</span>
      </div>
    </template>
    <template v-else>
      <div id="current-weather" @click="consult()">
        <img :src="weatherImage" alt="" />
        <div id="current-infos">
          <span id="temperature">{{ weatherData.current.temperature }}°</span>
          <span id="today-s-date">{{ clock | longDate }}</span>
        </div>
      </div>
    </template>
  </div>
</template>

<style lang="sass" scoped>
#weather-launcher-module
  align-items: center
  display: flex
  height: 100%
  justify-content: center
  overflow: hidden
  position: relative
  width: 100%

#alt-weather
  align-items: center
  display: flex
  justify-content: center
  width: 100%
  #msg
    bottom: 1rem
    font-family: 'RobotoThinItalic'
    font-size: .7em
    position: absolute

#current-weather
  img
    height: 100%
    margin-bottom: -0.5em
    width: 100%
  #current-infos
    align-items: baseline
    bottom: 0
    display: flex
    justify-content: space-around
    left: 0
    position: absolute
    right: 0
    #today-s-date
      font-family: 'RobotoRegular'
      font-size: 1.3em
      margin: .7rem 1rem
      right: 1rem
      z-index: 2
    #temperature
      font-family: 'RobotoThin'
      font-size: 3.6em
      letter-spacing: -18px
      left: 2rem
</style>

<script>
import AppIcon from '@/components/icons/AppIcon.vue';

export default {
  name: 'WeatherModule',

  components: {
    AppIcon,
  },

  props: {
    config: Object,
    clock: Date,
    entranceConfig: Object,
    contents: Object,
  },

  data() {
    return {
      hour: null,
      WEATHER_CODES: [
        { ClearSky: [113] },
        { FewClouds: [116] },
        { ScatteredClouds: [119] },
        { Mist: [143, 248] },
        { Snow: [179, 185, 227, 230, 260, 281, 284, 311, 338, 368, 335, 314, 317, 320, 323, 326, 332, 350, 362, 365, 371, 374, 377, 392] },
        { ShowerRain: [305, 308, 356, 359, 389] },
        { LightRain: [182, 263, 266, 293, 296, 299, 302, 176, 353, 386] },
        { Thunderstorm: [200] },
        { BrokenClouds: [122] },
      ],
    };
  },

  computed: {
    weatherImage() {
      const images = require.context('@/assets/weather', false, /\.png$/)
      let image = null;

      if (this.weatherData) {
        for (let i = 0; i < this.WEATHER_CODES.length; i++) {
          const element = this.WEATHER_CODES[i];
          if (Object.values(element)[0].includes(this.weatherData.current.weather_code)) {
            image = Object.keys(element)[0];
            break;
          }
        }

        if (!image) image = 'FewClouds.png'
      } else {
        image = 'FewClouds.png';
      }

      return images(`./${image}.png`);
    },

    weatherData() {
      let weatherData = null;

      if (this.contents.WeatherModule && this.clock) {
        const today = new Date();

        if (this.contents.WeatherModule) {
          weatherData = {};
          const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
          const regex = /\. ?/g;
          const formatedToday = new Intl
            .DateTimeFormat('ko-KR', options)
            .format(today).replace(regex, '-').substring(0, 10);
          this.hour = today.getHours();

          weatherData.current = this.contents.WeatherModule[formatedToday].hourly[this.hour];
        }
      } else {
        weatherData = {};
        weatherData.message = 'Météo en cours de chargement';
      }


      return weatherData;
    },
  },

  methods: {
    consult() {
      this.$router.push({ name: 'weather' });
    },
  },

  filters: {
    longDate(val) {
      let formatedDate;
      const options = {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
      };

      formatedDate = new Intl.DateTimeFormat('fr-FR', options).format(val);
      if (formatedDate.length >= 12) {
        options.weekday = 'short';
        formatedDate = new Intl.DateTimeFormat('fr-FR', options).format(val);
        if (formatedDate.length >= 12) {
          options.month = 'short';
          formatedDate = new Intl.DateTimeFormat('fr-FR', options).format(val);
        }
      }

      return val ?
        formatedDate.replace(formatedDate[0], formatedDate[0].toUpperCase())
        : '';
    },
  },
};
</script>
